import React, { useState } from 'react'
import { Button, Card, Col, DatePicker, Form, Row } from 'antd';
import { ICompany } from '../../../app/models/company';
import agent from '../../../app/api/agent';
import { toast } from "react-toastify";

interface IProps {
	company: ICompany;
}

const PodReport: React.FC<IProps> = ({ company }) => {	
	const [exporting, setExporting] = useState(false);
	const [form] = Form.useForm();
	
	const handleExport = async () => {
		try {
			const values = await form.validateFields();
			const from = values.fromDate.toDate();
			const to = values.toDate.toDate();
			
			// Check if date range is more than a week
			const diffInDays = (to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24);
			if (diffInDays > 7) {
				toast.error('Date range cannot exceed one week');
				return;
			}
			
			setExporting(true);
			// Download the POD archive directly
			const blob = await agent.Collection.downloadPodArchive(from, to, company.id);
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', `pod-files-${company.companyName}-${from.toISOString().split('T')[0]}-to-${to.toISOString().split('T')[0]}.zip`);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error(error);
			toast.error('Failed to export POD files');
		} finally {
			setExporting(false);
		}
	};
	
	return (
		<Card>
			<h3>POD Files Report</h3>
			<Form form={form} layout="vertical">
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							name="fromDate"
							label="From Date"
							rules={[{ required: true, message: 'Please select a from date' }]}
						>
							<DatePicker style={{ width: '100%' }} />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							name="toDate"
							label="To Date"
							rules={[{ required: true, message: 'Please select a to date' }]}
						>
							<DatePicker style={{ width: '100%' }} />
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col span={24}>
						<Button
							type="primary"
							onClick={handleExport}
							loading={exporting}
							style={{ marginLeft: '10px' }}
						>
							Export POD Files
						</Button>
					</Col>
				</Row>
			</Form>
		</Card>
	)
}

export default PodReport